import { Delete } from "@mui/icons-material";
import { Button, Dialog, DialogActions, DialogContent, DialogTitle, LinearProgress } from "@mui/material";
import { useContext, useState } from "react";
import { DataContext } from "../../DataContext";
import $data from "../../../services/$data";
import { AppContext } from "../../../AppContext";
;

function EmissionConfirmModal({open, onClose, parcel, year}) {
  const {selected} = useContext(AppContext);
  const {onGetParcels} = useContext(DataContext);
	const [loading, setLoading] = useState(false);

	const [status, setStatus] = useState({
		error: {},
		success: null,
	})
  console.log(parcel)
	const onSubmit = async () => {
		setLoading(true);
  
		try {
      let newStatus = parcel.status.map(s => {
        if(s.year.toString() === year) {
          let newS = {...s};
          newS.monitoring = 'Approved';
          return newS;
        }
        return {...s};
      })
			console.log(newStatus)
      
      await $data.patchMonitoringEmissionsStatus(parcel.statusId, newStatus, selected);
      await onGetParcels(selected);
			onClose();

		} catch(e) {
      console.log(e)
			setStatus(current =>  ({...current, error: e}));
		} finally {
			setLoading(false);
		}
	}

	return (
		<Dialog PaperProps={{className: 'co-background-white'}} open={open} onClose={onClose}>
			<DialogTitle>Submit emissions report for verification</DialogTitle>
			<DialogContent>
      <p className="co-text-primary text-bold">Are you sure you want to submit emissions report for verification?</p>
      <p className="co-text-primary text-bold">Please check if you provided neccessary input and supporting documents/geo-tagged photos to support your claim</p>

				{/* {user.user_type === 1 && <><WidgetDescription text="Parcel will be deleted in CropLab also" style={{marginBottom: '15px', fontWeight: 'bold', color: variables.dangerColor}} /> <br/><br/></>} */}

			</DialogContent>
			<DialogActions>
				<Button onClick={onClose} style={{lineHeight: 'unset'}}>Cancel</Button>
				<Button onClick={onSubmit} style={{lineHeight: 'unset'}} variant="contained" color="primary" startIcon={<Delete />}>Confirm</Button>
			</DialogActions>
			{loading && <LinearProgress color="primary" />}

		</Dialog>
	)
}

export default EmissionConfirmModal;